import { useContext, useEffect } from "react";
import { PageContext, SearchConfig } from "../components/layout/AppLayout";

export const usePage = (title: string, searchConfig?: SearchConfig) => {
  const { setPageTitle, setSearchConfig, searchValue } =
    useContext(PageContext);

  useEffect(() => {
    setPageTitle(title);
    setSearchConfig(searchConfig ?? null);
    return () => {
      setSearchConfig(null);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [title]);

  return { searchValue };
};
